import {
    cleanCommonParams,
} from './common';

const mapTagParams = (
    isCreate,
    {
        resources,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            tag: {
                ...cleanCommonParams(params),
            },
        });
    });
};

export { mapTagParams };
